@if (!errorText) {
  @if (chart?.type === 1) {
    <wf-barchart
      [labels]="labels"
      [data]="answers"
      [metadata]="metadata"
      [cutOffValues]="chartCutOffValues"
      [listenOnChanges]="listenOnChanges"></wf-barchart>
  }
  @if (chart?.type === 2) {
    <wf-linechart
      [labels]="labels"
      [data]="answers"
      [series]="series"
      [metadata]="metadata"
      [cutOffValues]="chartCutOffValues"
      [listenOnChanges]="listenOnChanges"></wf-linechart>
  }
} @else {
  <div class="chart-border">
    <div class="row">
      <div class="col-sm-12 text-center">
        <span class="chart-header">
          <span class="text-center header">{{ chart?.title }}</span>
        </span>
      </div>
    </div>
    <div class="no-results">
      <p>{{ errorText }}</p>
    </div>
  </div>
}
